import { type BreadcrumbItem, NavigationBreadcrumbs } from "~/features/breadcrumbs/components/NavigationBreadcrumbs";
import ShareButton from "~/features/shareButton/ShareButton";
import { Box } from "@schaeffler-commerce/design-system";

export interface Props {
  items: BreadcrumbItem[];
}

export function createNavigationBreadcrumbs(data: Props) {
  return (
    <div className={"scha__screen-only js-header-negative-offset"}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: { phone: 2, "desktop-s": 3 },
        }}
      >
        <NavigationBreadcrumbs {...data} />
        <ShareButton />
      </Box>
    </div>
  );
}
